<template>
<div class="lg:flex">
  <div class="lg:w-1/2 w-auto my-auto">
    <div class="my-auto text-center justify-center items-center">
      <label class="items-center">
        <input
          type="radio"
          v-model.trim="shipping"
          :value="shipping"
          class="form-radio"
          name="bool"
          checked
        />
        <span class="ml-2 text-2xl">Kostenloser Versand</span>
      </label>
    </div>
    <!-- <div class="my-auto text-center justify-center items-center py-6">
      <label class="items-center">
        Rabattcode:
        <input
          type="text"
          v-model.trim="cupone"
          class="border border-gray-800"
          name="bool"
          checked
        />
      </label>
    </div> -->
  </div>
  <OrderReview :cartItems="cartItems" :finalModel="finalModel"/>
</div>
</template>

<script>
import OrderReview from './OrderReview';
import { required } from "vuelidate/lib/validators";

export default {
  components: {
    OrderReview
  },
  props: {
    cartItems: Array,
    finalModel: Object
  },
  data() {
    return {
      step: 2,
      shipping: "Kostenloser Versand",
      cupone: ''
    };
  },
  computed: {
    total() {
      let som = 0;
      this.cartItems.map((item) => {
        som += item.sale_price;
      });
      return som;
    },
  },
  validations: {
    shipping: {
      required
    },
    form: ["shipping"]
  },
  methods: {
    validate() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid;
      this.$emit("on-validate", this.$data, isValid);
      return isValid;
    }
  }
};
</script>

<style>
</style>